
export class HouseAdditionInformation {
  constructor(
    public id: number,
    public phone: boolean,
    public tv: boolean,
    public furniture: boolean,
    public asphalt: boolean,
    public outbuildings: boolean,
    public euro_finish: boolean,
    public wood_finish: boolean,
    public garage: boolean,
    public sauna: boolean,
    public landscape_design: boolean,
    public forest: boolean,
    public river: boolean,
    public beautiful_place: boolean,
    public signaling: boolean,
    public security_territory: boolean,
    public terrace: boolean,
    public pool: boolean,
    public arbor: boolean,
    public fireplace: boolean,
    public garden: boolean,
    public greenhouse: boolean
  ) {}
}
